export default __webpack_public_path__ + "static/media/meal-benefit-disabled.fc10b8c9.png";